import { Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ModalAccionesUsuarioComponent} from '../modal-acciones-usuario/modal-acciones-usuario.component'
import { ModalAccionesLoccionesComponent } from '../modal-acciones-locciones/modal-acciones-locciones.component';
import {GenerarCSVService} from '../generar-csv.service'
import * as XLSX from 'xlsx'; //PARA GENERAR EXCEL

@Component({
  selector: 'app-componente-data7',
  templateUrl: './componente-data7.component.html',
  styleUrls: ['./componente-data7.component.scss']
})
export class ComponenteData7Component implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<ComponenteData7Component> = new Subject();
  tablavisible=false

  arraydeposts=[]
  alertaActiva=false;
  tipodeAlerta='primary'
  mensajeAlerta=''

  botondisabled=true
  arraydeempresas=[]

  usuario=null;
  procesodeEliminarActivo=false
  trabajando=false
  regional=''
  nombre=''

  empresaSeleccionada=""

  jsonData=[]

  constructor(public generarCSVService:GenerarCSVService) { }

  ngOnInit(): void {
    this.cargaempresas()
    
    // this.inicializadatatables(()=>{
    //   this.query1(()=>{
    //     this.dtTrigger.next();
    //   })
    // })
    
  }

  cargaempresas(){
    this.arraydeempresas=[]
    let query=firebase.firestore().collection("empresas").orderBy("nombre", "asc")
    query.get().then((docs)=>{
      docs.forEach((item)=>{
        if( ! this.arraydeempresas.includes(item.data().nombre)){
          this.arraydeempresas.push(item.data().nombre)
        }
      })
    })
  }

  // rerender() {
  //   console.log("RERENDER")
  //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {        
  //     // Destroy the table first
  //     dtInstance.destroy();
  //     //reload your data
  //     this.query1(()=>{
  //        // Call the dtTrigger to rerender after callback
  //        this.dtTrigger.next();
  //     })
  //   });
  // }

  cargareporte(){
    this.alerta("warning","Cargando registros...")
    this.query1(()=>{
     this.generaExcel() 
    })
  }

    query1(callback){
      this.arraydeposts=[];
      let query1 = firebase.firestore().collection("ptws").where("empresa","==",this.empresaSeleccionada);
      query1.get().then((docs)=>{
        docs.forEach((doc)=>{
          this.arraydeposts.push(doc);
        })
      }).then(()=>{
        this.alerta("success","Reporte generado")
        callback()
      }).catch((err)=>{
        console.log(err);
      })
    }

    inicializadatatables(callback) {
      this.dtOptions = {
        // Declare the use of the extension in the dom parameter
        dom: 'Bfrtip',
        "pageLength": 200,
        scrollX: false,
     
        // Configure the buttons
        buttons: [
          'colvis',
          'excel',
          // 'columnsToggle',
          'print'
        ]
      };
      callback()
    }

    ngOnDestroy(): void {
      // Do not forget to unsubscribe the event
      this.dtTrigger.unsubscribe();
    }

    detalles(item){

    }

    alerta(tipo,input){
      this.alertaActiva=true;
      this.mensajeAlerta=input;
      this.tipodeAlerta=tipo;
    }
  
  
  
    closeAlert(){
      this.alertaActiva=false
    }


    // PARA GENERAR EL EXCEL TOCA INSTALAR ESTAS DOS LIBRERIAS E IMPORTAR XLSX
    // npm install XLSX
    // npm install file-saver
    generaExcel(){

      this.alerta("warning","Generando excel")

      this.jsonData=[]
      this.arraydeposts.forEach((item,index)=>{

        let listadeEmpleados =''
        item.data().arrayDeEmpleados.forEach(element => {
          listadeEmpleados = listadeEmpleados + element.nombre+" "+element.id+" - "
        });


        this.jsonData.push({
          ticket:  item.data().ticket,
          empresa: item.data().empresa,
          fechaInicio: item.data().fechainicio,
          fechaFinal: item.data().fechafinal,
          solicitante: item.data().solicitante,
          descripcion: item.data().descripcionPTW,
          trabajadores: listadeEmpleados,
          cuenca: item.data().cuenca,
          locacion: item.data().pozoSeleccionado,
          status: item.data().status,
        })

        if(index == this.arraydeposts.length-1){
          this.alerta("success","¡Excel Generado!")
          // let element = document.getElementById('excel-table'); 

          const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.jsonData);
   
          /* generate workbook and add the worksheet */
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
   
          /* save to file */
          XLSX.writeFile(wb, this.fileName);
        }
      })
    }





	
/*name of the excel-file which will be downloaded. */ 
fileName= 'ExcelSheet.xlsx';  




    

}//fin de clase


